import Image from 'next/image';
import bannerData from './../../data/banners';
import { shuffleArray } from './../../util';
import { decode } from 'he';
import { useEffect, useState } from 'react';

const Banners = () => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const shuffledBanners = shuffleArray(bannerData).slice(0, 18);
    setBanners(shuffledBanners);
  }, [setBanners]);

  return (
    <div className="container-xl">
      <hr />
      <div className="pt-3 text-center">
        <p className="mb-4 fs-5 text-white">
          <strong>Employers We Work With</strong>
        </p>
        <div className="row justify-content-center">
          {banners.map((banner, key) => {
            const { name, bannerLogoUrl } = banner;

            return (
              <div className="col-6 col-sm-4 col-md-3 col-lg-2" key={key}>
                <div className="logo-card mb-3 py-2">
                  <Image
                    src={bannerLogoUrl}
                    alt={decode(name)}
                    layout="fill"
                    objectFit="contain"
                    className="fe-banner"
                    eager="true"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

module.exports = Banners;
